<template>
  <v-menu location="bottom" v-if="hasProfile" lang="common.alert.userMenu">
    <template #activator="{ props }">
      <v-btn variant="text" v-bind="props" aria-label="User profile menu">
        <v-icon color="black">account_circle</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-subheader style="height:20px">{{ t('common.userMenu.welcome') }},</v-list-subheader>
      <v-list-subheader class="font-weight-bold">{{ profile.firstName }} {{ profile.lastName }}</v-list-subheader>
      <v-divider />
      <v-list-item @click="logOut()" color="primary" aria-label="Exit">
        <template #prepend>
          <v-icon color="primary">exit_to_app</v-icon>
        </template>
        <v-list-item-title>{{ t('common.userMenu.exit') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import lang from '@/mixins/lang';
import { mapState } from 'vuex';

export default {
  name: 'UserProfile',
  mixins: [lang],
  data: () => ({
  }),
  methods: {
    logOut() {
      this.$router.push('/');
    },
  },
  computed: {
    ...mapState({
      profile: state => state.consumer.profiles[0],
    }),
    hasProfile() {
      return !!this.profile;
    },
  },
};
</script>

<style lang="scss">
  .theme--light.v-subheader {
    color: rgba(0,0,0,.75)!important;
  }
</style>